import React from 'react';
import { LogoContainer, CollabX } from './styles';
import { RetinaPicture } from '../../../../components/RetinaPicture';

export function Logos() {
  return (
    <LogoContainer aria-hidden="true">
      <RetinaPicture
        imagePath="/anchor-logo-header"
        alt="Anchor logo"
        className="anchorLogo"
      />
      <CollabX>X</CollabX>
      <RetinaPicture
        imagePath="/wordpress/logo-white"
        alt="WordPress logo"
        className="wpLogo"
      />
    </LogoContainer>
  );
}
